import './FormControlCaption-f58db5f7.css';

var classes = {"Caption":"prc-FormControl-Caption-tfuKU"};

export { classes as default };
